import React from "react";
import { EnableFundingToggleSwitch } from "../../../components";

const ForfeitureAccount = (props) => {
  const {
    planId,
    fundingId,
    planCashToggle,
    setForfeitureToggle,
    forfeitureToggle,
    achToggle,
  } = props;

  return (
    <div className="w-100 rounded forFeitureDetailsBox">
      <div className="accountgrid">
        <div>
          <div className="p-15 fw-600 d-flex forFeitureAccountHeader">
            Forfeiture Account
            <br></br>
          </div>
          <p className="forFeitureAccountDetails">
            When this option is enabled, forfeiture balance can be used for
            funding ER/Match contributions.
          </p>
        </div>

        <EnableFundingToggleSwitch
          planId={planId}
          modeOfFunding={"forfeitureAccountEnabled"}
          toggle={forfeitureToggle}
          setToggle={setForfeitureToggle}
          planCashToggle={planCashToggle}
          forfeitureToggle={forfeitureToggle}
          achToggle={achToggle}
          id={fundingId}
        />
      </div>
    </div>
  );
};

export default ForfeitureAccount;
